'use client';
import { useState } from 'react';

export function useHandleToggleItemList() {
  const [openItems, setOpenItems] = useState<Record<number | string, boolean>>(
    {}
  );

  const handleClick = (key: number | string) => {
    setOpenItems((prevOpenItems) => ({
      ...prevOpenItems,
      [key]: !prevOpenItems[key],
    }));
  };

  return { openItems, handleClick };
}
